import type { TaskInstance } from '../endpoints';
import getTaskPage from '../taskPage';
import readCompleteList from '../../readCompleteList';

export default async function getOpenTasksForPeriods(periodIds: string[]): Promise<TaskInstance[]> {
  const rows: TaskInstance[] = [];
  for (let start = 0; start < periodIds.length; start += 6) {
    // eslint-disable-next-line no-await-in-loop -- bound concurrent period reads
    const batch = await Promise.all(periodIds.slice(start, start + 6).map((id) => readCompleteList((limit) => getTaskPage({
      care_period_id: id,
      assigned_to_type: 'staff',
      status: ['pending', 'scheduled', 'in_progress', 'overdue'],
      sort: 'created',
      order: 'asc',
      offset: 0,
      limit,
    }), (task) => {
      if (String(task.id_care_period ?? task.care_period_id) !== id) throw new Error('Exception period mismatch.');
      return String(task.task_id ?? '');
    })));
    rows.push(...batch.flat());
  }
  return rows;
}
